import './App.css';
import { Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import { LanguageProvider } from './context/LanguageContext';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import AboutUs from './components/AboutUs';
import OurTeam from './components/OurTeam';
import Statistics from './components/Statistics';
import Ad from './components/Ad';
import Reviews from './components/Reviews';
import Partners from './components/Partners';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import AdminDashboard from './components/AdminDashboard';
import { SiWhatsapp } from 'react-icons/si';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <Hero />
              <Services />
              <AboutUs />
              <OurTeam />
              <Statistics />
              <Ad />
              <Reviews />
              <Partners />
              <ContactUs />
              <Footer />
              <a
                href="https://wa.me/+971567805342"
                className="floating-whatsapp"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat on WhatsApp"
              >
                <SiWhatsapp size={26} aria-hidden="true" />
              </a>
            </>
          } />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </div>
    </LanguageProvider>
  );
}

export default App;
